<template>
  <page-wrapper title="เพิ่มคูปองส่วนลด" :hasPad="true">
    <coupon-editor v-model="form"></coupon-editor>
    <div class="mt-5">
      <sc-button
        class="btn-submit"
        variant="primary"
        @click="handleClickSubmitButton"
      >บันทึก</sc-button>
    </div>
  </page-wrapper>
</template>

<script>
import { toOptionalISOString } from "@/lib/dateTime";
import PageWrapper from "@/lib/components/PageWrapper";
import ScButton from "@/lib/components/ScButton";
import { baanRueJaiClient } from "@/dependencies";
import CouponEditor from "../components/CouponEditor";

export default {
  components: {
    PageWrapper,
    ScButton,
    CouponEditor
  },
  data() {
    const form = {
      code: "",
      effectiveDate: null,
      expiryDate: null,
      expiredDaysAfterTransfered: null,
      usageQuota: null,
      usageQuotaPerUser: null,
      minimumPurchasedAmount: null,
      maximumDiscountAmount: null,
      selectedPackages: [],
      discountAmount: null,
      discountPercentAmount: null,
      supportedProjectIds: null,
      isFirstTimeOnly: false,
      isActionEdit: false
    };

    return {
      form
    };
  },
  computed: {
    isNegativeMinimumPurchasedAmount() {
      return (this.form.minimumPurchasedAmount && this.form.minimumPurchasedAmount < 0);
    }
  },
  created() {
    this.setup();
  },
  methods: {
    setup() {
      this.setupData();
    },
    setupData() {},
    async createCoupon() {
      const params = {
        ...this.form,
        effectiveDate: toOptionalISOString(this.form.effectiveDate),
        expiryDate: toOptionalISOString(this.form.expiryDate),
        selectedPackages: undefined,
        selectedPackageIds: this.form.selectedPackages.map(({ id }) => +id)
      };

      const response = await baanRueJaiClient.admin.subscriptions.coupons.post(
        params
      );

      return response.data.result;
    },
    async handleClickSubmitButton() {
      if (this.isNegativeMinimumPurchasedAmount) {
        alert("ไม่สามารถเพิ่มคูปองได้เนื่องจากยอดซื้อขั้นต่ำน้อยกว่า 0")
        return;
      }

      try {
        await this.createCoupon();
        this.$router.push({ name: "CouponListPage" });
      } catch (error) {
        alert(error.response.data.message);
        console.error(error);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.btn-submit {
  float: right;
}
</style>



// WEBPACK FOOTER //
// src/features/subscriptions/modules/coupons/pages/CouponAddPage.vue